import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { apiServer } from '../../../../api';
import { useTarefa } from "../../../../contexts/TarefaContext";
import { useLogin } from "../../../../contexts/LoginContext";
import { useCliente } from "../../../../contexts/ClienteContext";
import { IGrupoTarefa } from "../../../../types/tarefa";

const filtro = createFilterOptions<IGrupoTarefa>();

const GrupoTarefa = () => {
    const [tarefa, setTarefa] = useTarefa();
    const [login] = useLogin();
    const [cliente] = useCliente();
    const [nomeGrupo, setNomeGrupo] = useState(tarefa.grupo?.nome || "");
    const [grupos, setGrupos] = useState<IGrupoTarefa[]>([]);

    useEffect(() => {
        const activeClienteId = cliente.id || login.usuario?.usuarioCliente?.clienteID;
        const endpoint = activeClienteId ? `/grupo-tarefa-agendada/${activeClienteId}` : "/grupo-tarefa-agendada";

        apiServer<IGrupoTarefa[]>().get(endpoint, login.accessToken)
            .then((response) => {
                var grupos = response.data;
                setGrupos(grupos || []);
            }).catch(() => {});
    }, [cliente.id, login.usuario?.usuarioCliente?.clienteID, login.accessToken]);

    function handleGrupoAlterado(event: React.SyntheticEvent<Element, Event>, newValue: string | IGrupoTarefa | null): void {
        event.preventDefault();

        if (typeof newValue === 'string') {
            setTarefa({
                ...tarefa, grupo: {
                    id: "",
                    nome: newValue
                }
            });

            setNomeGrupo(newValue);

        } else if (newValue) {
            setTarefa({
                ...tarefa, grupo: {
                    id: newValue.id,
                    nome: newValue.nome
                }
            });

            setNomeGrupo(newValue.nome);
        }
    }

    return (
        <Autocomplete
            value={nomeGrupo}
            onChange={handleGrupoAlterado}
            filterOptions={(options, params) => {
                const filtered = filtro(options, params);

                const { inputValue } = params;
                const isExisting = options.some((option) => inputValue === option.nome);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        nome: inputValue,
                        id: "",
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            id="grupoTarefa"
            options={grupos}
            getOptionLabel={(option) => {
                if (typeof option === 'string')
                    return option;

                if (option.id)
                    return option.nome;

                return option.nome;
            }}
            renderOption={(props, option) => <li {...props}>{option.nome}</li>}
            freeSolo
            renderInput={(params) => (
                <TextField required {...params} label="Grupo Tarefa" />
            )}
        />
    );

}

export default GrupoTarefa;